// extracted by mini-css-extract-plugin
module.exports = {"button_class":"Button_button_class__kt5kU","connect_width":"Button_connect_width__3KrBR"};